// src/features/tienda/store-switcher.tsx
import { ChevronDown, Store } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import type { MyStore } from '@/api/schemas/tienda';

export function StoreSwitcher({
  stores,
  active,
  onChange,
}: {
  stores: MyStore[];
  active: MyStore | null;
  onChange: (id: string) => void;
}) {
  if (!active) return null;
  if (stores.length < 2) {
    return (
      <span className="flex items-center gap-2 rounded-lg border border-border bg-surface px-3 py-1.5 text-sm text-text-primary">
        <Store size={16} aria-hidden className="text-gold" />
        <span className="truncate">{active.storeName}</span>
      </span>
    );
  }
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label={`Tienda activa: ${active.storeName}. Cambiar de tienda`}
          className="flex items-center gap-2 rounded-lg border border-border bg-surface px-3 py-1.5 text-sm text-text-primary hover:bg-elevated"
        >
          <Store size={16} aria-hidden className="text-gold" />
          <span className="truncate">{active.storeName}</span>
          <ChevronDown size={14} className="text-text-muted" aria-hidden />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {stores.map((s) => (
          <DropdownMenuItem
            key={s.id}
            onSelect={() => onChange(s.id)}
            hint={s.id === active.id ? 'Tienda activa' : s.city}
          >
            {s.storeName}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
